module.exports = __webpack_public_path__ + "static/media/logout.e6a8e2c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logout.svg
// module id = 578
// module chunks = 0